/* eslint-disable no-undef */

import { useEffect, useState } from 'react';
import { createZoomClientEvent } from 'Shared/api';
import { updateZoomContextAction } from 'Shared/actions/user';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router';

function ZoomJavascriptSDKHandler() {
  const workspaceId = useSelector(state => state.workspace.id);
  const [runningContext, setRunningContext] = useState(null);
  const dispatch = useDispatch();

  const { pathname } = useLocation();

  async function configureSdk() {
    try {
      // Configure the JS SDK, required to call JS APIs in the Zoom App
      const configResponse = await zoomSdk.config({
        size: { width: 580, height: 360 },
        capabilities: ['onSendAppInvitation', 'getRunningContext', 'openUrl'],
      });
      // The config method returns the running context of the Zoom App
      setRunningContext(configResponse.runningContext);
    } catch (error) {
      console.log('There was an error configuring the Zoom JS SDK: ', error);
    }
  }

  useEffect(() => {
    configureSdk();
  }, [pathname]);

  useEffect(() => {
    const zoomShareCallback = data => {
      createZoomClientEvent({ event_type: 'send_app', data, workspace_id: workspaceId });
    };

    try {
      zoomSdk.addEventListener('sendAppInvitation', zoomShareCallback);
    } catch (error) {
      console.log('There was an error configuring the callbacks for the Zoom JS SDK');
    }

    return () => {
      zoomSdk?.removeEventListener('sendAppInvitation', zoomShareCallback);
    };
  }, [workspaceId]);

  useEffect(() => {
    if (runningContext) dispatch(updateZoomContextAction({ runningContext }));
  }, [runningContext]);

  return null;
}

export default ZoomJavascriptSDKHandler;
